
if (typeof RedactorPlugins === "undefined"){
	window.RedactorPlugins = {};
}

RedactorPlugins.customTags = {
	init: function() {
		var dropdown = {
			current_day: {
				id: 'current-day',
				title: '['+Loc.g('Numéro du jour courant')+']',
				callback: this.insertTag
			},
			current_day_name: {
				id: 'current-day-name',
				title: '['+Loc.g('Nom du jour courant')+']',
				callback: this.insertTag
			},
			current_month: {
				id: 'current-month',
				title: '['+Loc.g('Numéro du mois courant')+']',
				callback: this.insertTag
			},
			current_month_name: {
				id: 'current-month-name',
				title: '['+Loc.g('Nom du mois courant')+']',
				callback: this.insertTag
			},
			last_month: {
				id: 'last-month',
				title: '['+Loc.g('Numéro du mois dernier')+']',
				callback: this.insertTag
			},
			last_month_name: {
				id: 'last-month-name',
				title: '['+Loc.g('Nom du mois dernier')+']',
				callback: this.insertTag
			},
			next_month: {
				id: 'next-month',
				title: '['+Loc.g('Numéro du mois prochain')+']',
				callback: this.insertTag
			},
			next_month_name: {
				id: 'next-month-name',
				title: '['+Loc.g('Nom du mois prochain')+']',
				callback: this.insertTag
			},
			year: {
				id: 'current-year',
				title: '['+Loc.g('Année courante')+']',
				callback: this.insertTag
			},
			next_year: {
				id: 'next-year',
				title: '['+Loc.g('Année prochaine')+']',
				callback: this.insertTag
			},
			last_year: {
				id: 'last-year',
				title: '['+Loc.g('Année dernière')+']',
				callback: this.insertTag
			},
			next_month_year: {
				id: 'next-month-year',
				title: '['+Loc.g('Année du mois prochain')+']',
				callback: this.insertTag
			},
			last_month_year: {
				id: 'last-month-year',
				title: '['+Loc.g('Année du mois dernier')+']',
				callback: this.insertTag
			},
			next_month_trimester: {
				id: 'next-month-trimester',
				title: '['+Loc.g('Numéro du mois du prochain trimestre')+']',
				callback: this.insertTag
			},
			last_month_trimester: {
				id: 'last-month-trimester',
				title: '['+Loc.g('Numéro du mois du précedent trimestre')+']',
				callback: this.insertTag
			},
			next_month_biannual: {
				id: 'next-month-biannual',
				title: '['+Loc.g('Numéro du mois du prochain semestre')+']',
				callback: this.insertTag
			},
			last_month_biannual: {
				id: 'last-month-biannual',
				title: '['+Loc.g('Numéro du mois du précédent semestre')+']',
				callback: this.insertTag
			},
			custom: {
				id: 'custom',
				title: '['+Loc.g('Customisé')+']',
				callback: this.insertTag
			}
		};

		this.buttonAddSeparator();
		this.buttonAdd('customTags', 'Tags', false, dropdown);
	},
	insertTag: function(obj, event, key) {
		if(key.id == 'custom') {
			this.insertHtml('<span class="customTag" contenteditable="false" spellcheck="false" data-id="' + key.id + '">' + Loc.g('Moment de création') + '&nbsp;<select class="modifier no-customform" onchange="RedactorMore.saveCustomTag(this);"><option value="plus">+</option><option value="minus">-</option></select>' + '&nbsp;<input type="text" class="number" style="width: 40px; height: 19px;" onchange="RedactorMore.saveCustomTag(this);" value="0" />' + '&nbsp;<select class="interval no-customform" onchange="RedactorMore.saveCustomTag(this);"><option value="day">' + Loc.g('jour(s)') + '</option><option value="week">' + Loc.g('semaine(s)') + '</option><option value="month">' + Loc.g('mois') + '</option><option value="year">' + Loc.g('année') + '</option></select>' + '&nbsp;' + Loc.g('sous forme de') + '&nbsp;<select class="format no-customform" onchange="RedactorMore.saveCustomTag(this);"><option value="number_day">' + Loc.g('numéro du jour') + '</option><option value="name_day">' + Loc.g('nom du jour') + '</option><option value="name_first_day">' + Loc.g('nom du premier jour du mois') + '</option><option value="number_first_day">' + Loc.g('numéro du premier jour du mois') + '</option><option value="name_last_day">' + Loc.g('nom du dernier jour du mois') + '</option><option value="number_last_day">' + Loc.g('numéro du dernier jour du mois') + '</option><option value="number_month">' + Loc.g('numéro du mois') + '</option><option value="name_month">' + Loc.g('nom du mois') + '</option><option value="number_year">' + Loc.g('numéro de l\'année') + '</option></select>' + '&nbsp;<quit class="fa fa-times fa-13" onclick="RedactorMore.removeCustomTag(this);" onmouseover="RedactorMore.customTagDeleteFashion(this,true);" onmouseout="RedactorMore.customTagDeleteFashion(this,false);"></quit></span>');
		} else {
			this.insertHtml('<span class="customTag" contenteditable="false" spellcheck="false" data-id="' + key.id + '">' + key.title + '&nbsp;<quit class="fa fa-times fa-13" onclick="RedactorMore.removeCustomTag(this);" onmouseover="RedactorMore.customTagDeleteFashion(this,true);" onmouseout="RedactorMore.customTagDeleteFashion(this,false);"></quit></span>');
		}
	}
};

RedactorPlugins.massmailingTags = {
	init: function() {
		var dropdown = {
			civil: {
				id: '#civil#',
				title: Loc.g('Civilité du destinataire'),
				callback: this.insertTag
			},
			name: {
				id: '#name#',
				title: Loc.g('Nom du destinataire'),
				callback: this.insertTag
			},
			forename: {
				id: '#forename#',
				title: Loc.g('Prénom du destinataire'),
				callback: this.insertTag
			},
			company: {
				id: '#company#',
				title: Loc.g('Société du destinataire'),
				callback: this.insertTag
			},
			optin: {
                id: '#url_subscribe_campaign#',
                title: Loc.g('Url d’inscription aux campagnes marketings'),
				callback: this.insertTag
			},
			optout: {
                id: '#url_unsubscribe_campaign#',
                title: Loc.g('Url de désinscription aux campagnes marketings'),
				callback: this.insertTag
			},
		};

		this.buttonAddSeparator();
		this.buttonAdd('customTags', 'Personnalisation', false, dropdown);
	},
	insertTag: function(obj, event, key) {
		this.insertHtml(key.id);
	}
};

window.RedactorMore = {
	customTagDeleteFashion: function(item, over) {
		var el = $(item);
		if(over) {
			el.addClass('fa-black').addClass('pointer');
		} else {
			el.removeClass('fa-black').removeClass('pointer');
		}
	},
	
	removeCustomTag: function(item) {
		var redactor = $(item).parents('.redactor_redactor');
		$(item).parent().remove();
		redactor.trigger('keyup');
	},
	
	saveCustomTag: function(element) {
		var current = $(element);
		var parent	= current.closest('.customTag');
		
		var data	= {
			modifier: parent.find('.modifier').val(),
			number	: parent.find('.number').val(),
			interval: parent.find('.interval').val(),
			format	: parent.find('.format').val()
		};
		
		parent.attr('data-custom', btoa(JSON.stringify(data)));
		
		// force html in the textarea
		var div_content = parent.closest('.redactor_redactor').html();
		parent.closest('.redactor_redactor').parent().find('textarea').val(div_content);
	}
};

RedactorPlugins.fontcolor = {
	init: function()
	{
		var colors = ['#ffffff', '#000000', '#eeece1', '#1f497d', '#4f81bd', '#c0504d', '#9bbb59', '#8064a2', '#4bacc6', '#f79646', '#ffff00', '#f2f2f2', '#7f7f7f', '#ddd9c3', '#c6d9f0', '#dbe5f1', '#f2dcdb', '#ebf1dd', '#e5e0ec', '#dbeef3', '#fdeada', '#fff2ca', '#d8d8d8', '#595959', '#c4bd97', '#8db3e2', '#b8cce4', '#e5b9b7', '#d7e3bc', '#ccc1d9', '#b7dde8', '#fbd5b5', '#ffe694', '#bfbfbf', '#3f3f3f', '#938953', '#548dd4', '#95b3d7', '#d99694', '#c3d69b', '#b2a2c7', '#b7dde8', '#fac08f', '#f2c314', '#a5a5a5', '#262626', '#494429', '#17365d', '#366092', '#953734', '#76923c', '#5f497a', '#92cddc', '#e36c09', '#c09100', '#7f7f7f', '#0c0c0c', '#1d1b10', '#0f243e', '#244061', '#632423', '#4f6128', '#3f3151', '#31859b', '#974806', '#7f6000'];
		var buttons = ['fontcolor', 'backcolor'];

		this.buttonAddSeparator();

		for (var i = 0; i < 2; i++)
		{
			var name = buttons[i];

			var $dropdown = $('<div class="redactor_dropdown redactor_dropdown_box_' + name + '" style="display: none; width: 210px;">');

			this.pickerBuild($dropdown, name, colors);
			$(this.$toolbar).append($dropdown);

			this.buttonAdd(name, this.opts.curLang[name], $.proxy(function(btnName, $button, btnObject, e)
			{
				this.dropdownShow(e, btnName);

			}, this));
		}
	},
	pickerBuild: function($dropdown, name, colors)
	{
		var rule = 'color';
		if (name === 'backcolor') rule = 'background-color';

		var _self = this;
		var onSwatch = function(e)
		{
			e.preventDefault();

			var $this = $(this);
			_self.pickerSet($this.data('rule'), $this.attr('rel'));

		}

		var len = colors.length;
		for (var z = 0; z < len; z++)
		{
			var color = colors[z];

			var $swatch = $('<a rel="' + color + '" data-rule="' + rule +'" href="#" style="float: left; font-size: 0; border: 2px solid #fff; padding: 0; margin: 0; width: 15px; height: 15px;"></a>');
			$swatch.css('background-color', color);
			$dropdown.append($swatch);
			$swatch.on('click', onSwatch);
		}

		var $elNone = $('<a href="#" style="display: block; clear: both; padding: 4px 0; font-size: 11px; line-height: 1;"></a>')
		.html(this.opts.curLang.none)
		.on('click', function(e)
		{
			e.preventDefault();
			_self.pickerSet(rule, false);
		});

		$dropdown.append($elNone);
	},
	pickerSet: function(rule, type)
	{
		this.bufferSet();

		this.$editor.focus();
		this.inlineRemoveStyle(rule);
		if (type !== false) this.inlineSetStyle(rule, type);
		if (this.opts.air) this.$air.fadeOut(100);
		this.sync();
	}
};

RedactorPlugins.fontsize = {
	init: function()
	{
		var fonts = [7, 8, 9, 10, 11, 12, 14, 16, 18, 20, 24, 28, 30];
		var that = this;
		var dropdown = {};

		$.each(fonts, function(i, s)
		{
			dropdown['s' + i] = { title: s + 'px', callback: function() { that.setFontsize(s); } };
		});

		dropdown['remove'] = { title: 'Remove font size', callback: function() { that.resetFontsize(); } };

		this.buttonAdd( 'fontsize', 'Change font size', false, dropdown);
	},
	setFontsize: function(size)
	{
		this.inlineSetStyle('font-size', size + 'px');
	},
	resetFontsize: function()
	{
		this.inlineRemoveStyle('font-size');
	}
};

RedactorPlugins.fontsizePDF = {
	init: function()
	{
		var fonts = [7, 8, 9, 10, 11, 12, 14, 16, 18, 20, 24, 28, 30];
		var that = this;
		var dropdown = {};

		$.each(fonts, function(i, s)
		{
			dropdown['s' + i] = { title: s + 'pt', callback: function() { that.setFontsize(s); } };
		});

		dropdown['remove'] = { title: 'Remove font size', callback: function() { that.resetFontsize(); } };

		this.buttonAdd( 'fontsize', 'Change font size', false, dropdown);
	},
	setFontsize: function(size)
	{
		this.inlineSetStyle('font-size', size + 'pt');
	},
	resetFontsize: function()
	{
		this.inlineRemoveStyle('font-size');
	}
};

RedactorPlugins.fontfamily = {
	init: function ()
	{
		var fonts = [ 'Arial', 'Helvetica', 'Times New Roman', 'Monospace', 'Open sans' ];
		var that = this;
		var dropdown = {};

		$.each(fonts, function(i, s)
		{
			dropdown['s' + i] = { title: s, callback: function() { that.setFontfamily(s); }};
		});

		dropdown['remove'] = { title: 'Remove font', callback: function() { that.resetFontfamily(); }};

		this.buttonAdd('fontfamily', 'Change font family', false, dropdown);
	},
	setFontfamily: function (value)
	{
		this.inlineSetStyle('font-family', value);
	},
	resetFontfamily: function()
	{
		this.inlineRemoveStyle('font-family');
	}
};

/**
 * Ensure that double braces are not interpreted by vueJs
 */
RedactorPlugins.safeMustache = {
    init: function()
	{
        this.onCreated()
        this.beforeSubmit()
	},
    /**
     * Do something on created textarea redactor
     *   
     *  - Change double braces code assci to their html equivalent
     * 
     * @return {void}
     */
    onCreated() {
        this.$editor.html(this.safeToFront(this.$editor.html()))
        this.sync()
    },
    /**
     * Do something before submit form with textarea redactor
     * 
     *  - Call safeToBack method
     * 
     * @return {void}
     */
    beforeSubmit() {
        $('form').on('submit', (e) => this.safeToBack());
    },
    /**
     * Change double braces code assci to their html equivalent
     */
    safeToFront(value) {
        const that = this
        const map = {
            '{{': '&amp;#123;&amp;#123;|&amp#123;&amp#123;',
            '}}': '&amp;#125;&amp;#125;|&amp#125;&amp#125;'
        };
        return that.mapReplace(value, map)
    },
    /**
     * Change double braces html to their ascii equivalent
     */
    safeToBack() {
        const that = this
        const map  = {
            '&amp#123;&amp#123;': '{{',
            '&amp#125;&amp#125;': '}}',
        };
        $('textarea.redactor').each(function() {
            $(this).val(that.mapReplace($(this).val(), map))
        })
    },
    /**
     * Change double braces code assci to their html equivalent
     */
    safeRedactorOnClick () {
        const that = this
        const map = {
            '{{': '&amp;#123;&amp;#123;|&amp#123;&amp#123;',
            '}}': '&amp;#125;&amp;#125;|&amp#125;&amp#125;'
        };
        $('.displayRedactorOnClick').each(function() {
            this.innerHTML = that.mapReplace(this.innerHTML, map)
        })
    },
    /**
     * For the input string, replace the search pattern with the replacement part of map object
     * @param {string} str string to manipulate
     * @param {object} map object of element to replace { replacement part : search pattern}
     * @return {string} return string modify
     */
    mapReplace: function(str, map = {}) {
        for (const [replace, pattern] of Object.entries(map)) {
            str = str.replace(new RegExp(pattern, 'g'), replace);
        };
        return str;
    },

}
